import { gql } from '@apollo/client';

export const FILTERED_SCHOOL_PROGRESSIONS = gql`
  query FilteredSchoolProgressions($input: SearchData!) {
    schoolProgressions: filteredProgressionDatas(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          averageMark
          class
          cluster
          control
          circuit
          emisNumber
          level1
          level2
          level3
          level4
          level5
          level6
          level7
          numberPassed
          numberEnrolled
          numberWrote
          passRate
          term
          treatment
          year
          district {
            id
            name
          }
          grade {
            id
            value
          }
          subject {
            id
            name
          }
          promotionStatus {
            id
            name
          }
          region {
            id
            name
          }
          institution {
            id
            name
          }
        }
      }
    }
  }
`;
